import React, { useState } from 'react'
import './navbar.css'
import logo from '../../assets/logo.png'
import contact_img from '../../assets/contact.png'
import {Link} from 'react-scroll'
import menu from '../../assets/menu.png'

const Navbar = () => {
  const [showMenu, setShowMenu]=useState(false);
  return (
   <nav className="navbar">
    <img src={logo} alt='logo' className='logo'/>
    <div className="desktopMenu">
<Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItem'>Home</Link>
<Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className='desktopMenuListItem'>Skills</Link>
<Link activeClass='active' to='myworks' spy={true} smooth={true} offset={-50} duration={500} className='desktopMenuListItem'>Projects</Link>
<Link activeClass='active' to='contactPage' spy={true} smooth={true} offset={-50} duration={500} className='desktopMenuListItem'>Resume</Link>

    </div>
    <button className='desktopMenuBtn' onClick={()=>{
document.getElementById('contact').scrollIntoView({behavior:'smooth'});
    }}>
        <img src={contact_img} alt='' className='desktopMenuImg'/> Contact Me
    </button>

    <img src={menu} alt='menu' className='mobMenu' onClick={()=>setShowMenu(!showMenu)}/>
    <div className="navMenu" style={{display:showMenu? 'flex':'none'}}>
<Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Home</Link>
<Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Skills</Link>
<Link activeClass='active' to='myworks' spy={true} smooth={true} offset={-50} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Projects</Link>
<Link activeClass='active' to='contactPage' spy={true} smooth={true} offset={-50} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Resume</Link>
<Link activeClass='active' to='footer' spy={true} smooth={true} offset={-50} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Contact</Link>
    </div>
   </nav>
  )
}

export default Navbar 
